import { useTranslation } from 'react-i18next';

import React from 'react';

import { Text } from '@thinkific/chalk';

import CommunityUsers from 'components/CommunityUsers';
import Image from 'components/Image';

import * as css from './Hero.css';

interface HeroProps {
  src?: string;
  description: string;
  alt?: string;
  firstName?: string;
}

const Hero = ({ src, alt, description, firstName }: HeroProps) => {
  const { t } = useTranslation();

  return (
    <div className={css.heroWrapper}>
      {src && (
        <Image alt={alt || ''} className={css.heroImage} height={160} src={src} width={640} />
      )}
      <div className={css.heroBody}>
        <div className={css.heroIntro}>
          <Text variant="display.sm">
            {t('components-hero-welcome', 'Welcome')} {firstName} 👋
          </Text>
          {description && <Text variant="body.base">{description}</Text>}
        </div>
        <CommunityUsers />
      </div>
    </div>
  );
};

export default Hero;
